import { BaseServices, HttpMethod } from '@services/base'

export default async (biometricToken: string, accessToken?: string) => {
  const pathname = process.env.REACT_APP_BIOMETRICS_VALIDATE_WEB
  const method = HttpMethod.POST
  const host = process.env.REACT_APP_API_HOST
  const headers: Record<string, string> = {
    Authorization: `Bearer ${accessToken}`,
  }

  return BaseServices.request({
    headers,
    pathname,
    method,
    host,
    data: { biometricToken },
  })
}
